import React from 'react'
import styled from "styled-components";
import {Flex} from "../styles/GlobalStyle";
import {
  Radio,
  FormControlLabel,
  FormControl,
  Checkbox,
  TextField,
  RadioGroup
} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import AccessTime from '@material-ui/icons/AccessTime';
import clsx from 'clsx';
import Moment from 'moment'
import momentLocalizer from 'react-widgets-moment';
import "react-widgets/dist/css/react-widgets.css";
import Property from "../model/property"
import {get, map, find, isUndefined, isEmpty} from "lodash"
import moment from "moment"
import {withTranslation} from 'react-i18next';
import DateTimePickerComponent from "../modules/precheckin/components/DateTimePickerComponent";
import SignatureSelector from "./SignatureSelector";
import ProcessImage from "react-imgpro";
import {TextQuantity} from "../modules/basketdetail/style/BasketStoreStyle";

Moment.locale('en')
momentLocalizer()

const Selector = (props) => {
  const selectionType = props.item.selection_type
  let renderData = <RenderDefault />
  if (selectionType === "text_input") {
    renderData = <TextInput {...props} />
  } else if (selectionType === "pick_one_price") {
    renderData = <RadioButtonPrice {...props} />
  } else if (selectionType === "pick_one" ||
    selectionType === "pick_table_dropdown") {
    const newProps = { ...props }

    if (selectionType === "pick_table_dropdown") {
      const tableNo = Property.getTableNo()
      const showSelectedOnly = !!tableNo; 
      newProps.item = {
        ...props.item,
        default: tableNo,
        showSelectedOnly
      }
    }    
    renderData = <RadioButton {...newProps} />
  } else if (selectionType === "pick_multiple_price") {
    renderData = <CheckBoxsPrice {...props} />
  } else if (selectionType === "pick_multiple") {
    renderData = <CheckBoxs {...props} />
  } else if (selectionType === "pick_date") {
    renderData = <DatePicker {...props} />
  } else if (selectionType === "pick_time") {
    renderData = <TimePicker {...props} />
  } else if (selectionType === "pick_date_and_time") {
    renderData = <DateTimePickerComponents {...props} />
  } else if (selectionType === "pick_number") {
    renderData = <NumberPicker {...props} />
  } else if (selectionType === "pick_product_price") {
    renderData = <ProductPrice {...props} />
  } else if (selectionType === "pick_dropdown") {
    renderData = <Dropdown {...props} />
  } else if (selectionType === "text_input_room") {
    renderData = <TextInput {...props} />
  } else if (selectionType === "pick_time_relative") {
    renderData = <PickTime {...props} />
  } else if (selectionType === "dropdowns") {
    renderData = <DropdownList {...props} />
  } else if (selectionType === "add_photo") {
    renderData = <Uploader {...props} />
  } else if (selectionType === "signature") {
    renderData = <Signature {...props} />
  } else if (selectionType === "add_to_guest_profile") {
    renderData = <TwoRadioButton {...props} />
  } else if (selectionType === "email_input") {
    renderData = <TextInput {...props} />
  }
  return (
    <Flex flex={1}>
      {props.item.selection_type === "static_text" ?
        <Flex>
          <StaticText className={'staticText'}>{props.item.title}</StaticText>
          {props.item.force_input ? <TitleSelectorRight
            className={'chooseTextRight'}>{props.t("REQUIRED")}</TitleSelectorRight> : null}
        </Flex>
        :
        <Flex container backgroundColor={"#EAEAEA"}
              justifyContent={"space-between"}>
          <FlexContainer>
            <TitleSelector
              className={'chooseTextLeft'}>{props.item.title}</TitleSelector>
          </FlexContainer>
          {props.item.force_input ? <TitleSelectorRight
            className={'chooseTextRight'}>{props.t("REQUIRED")}</TitleSelectorRight> : null}
        </Flex>
      }
      {props.item.force_input ?
        validateInput(props.item, props.checkValidation) ?
          null :
          <TitleAlert
            className={'validationText'}>{props.t('PLEASE_FILL_OUT_REQUIRED')}</TitleAlert>
        :
        null
      }
      {props.item.force_input ?
        validateEmail(props) ?
          null :
          <TitleAlert
            className={'validationText'}>{props.t('INVALID_EMAIL')}</TitleAlert>
        :
        null
      }
      {renderData}
    </Flex>
  )
}

export default withTranslation()(Selector)

function validateInput(data, checkValidation) {
  let validateDataInput = true
  if (checkValidation) {
    if (data.selection_type === "pick_date" || data.selection_type === "pick_time" ||
      data.selection_type === "pick_time_relative" || data.selection_type === "pick_date_and_time" ||
      data.selection_type === "pick_date_and_static_time" || data.selection_type === "pick_date_spa_booker" ||
      data.selection_type === "pick_number" || data.selection_type === "text_input" ||
      data.selection_type === "text_input_room" || data.selection_type === "signature" || data.selection_type === "pick_table_dropdown" ||
      data.selection_type === "add_photo") {
      if (!data.values) {
        validateDataInput = false
      } else {
        validateDataInput = true
      }
    }

    if (data.selection_type === "pick_one" || data.selection_type === "pick_one_price" || data.selection_type === "pick_table_dropdown") {
      for (const j in data.values) {
        if (data.values[j].select === false) {
          validateDataInput = false
        } else {
          validateDataInput = true
          break
        }
      }
    }

    if (data.selection_type === "pick_multiple" || data.selection_type === "pick_multiple_price") {
      for (const k in data.values) {
        if (data.values[k].select === false) {
          validateDataInput = false
        } else {
          validateDataInput = true
          break
        }
      }
    }

    if (data.selection_type === "dropdowns") {
      if (!data.value) {
        validateDataInput = false
      } else {
        validateDataInput = true
      }
    }

    if (data.selection_type === "pick_dropdown") {
      const dataSelected = find(get(data, 'values', []), { select: true })
      if (isUndefined(dataSelected)) {
        validateDataInput = false
      } else {
        validateDataInput = true
      }
    }
  }
  return validateDataInput
}

const validateEmail = (props) => {
  if (props.item.values === undefined || props.item.selection_type !== "email_input") {
    return true
  }

  Property.setInputEmail(props.item.values)
  if(String(props.item.values)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )) {
      Property.setEmailInvalid(false)
      return true;
    }
    Property.setEmailInvalid(true)

  return false;
}

const TextInput = (props) => {
  const classes = textInputStyles()

  React.useEffect(() => {
    if (props.item.values === undefined) {
      props.onChange({ target: { value: "" } });
    }
    // eslint-disable-next-line
  }, []);

  if (props.item.full_width) {
    return (
      <Flex flex={1} margin={"32px 32px 16px 32px"}>
        <form noValidate autoComplete="off">
          <TextField
            onChange={props.onChange}
            value={props.item.values || ""}
            id={`outlined-multiline-static-${props.index}`}
            placeholder={props.item.placeholder} fullWidth multiline variant="outlined"
            InputProps={{
              classes: {
                input: classes.resize,
                notchedOutline: classes.notchedOutline
              }
            }}
          />
        </form>
      </Flex>
    )
  } else {
    return (
      <Flex flex={1} margin={"32px 32px 16px 32px"}>
        <form noValidate autoComplete="off">
          <TextField
            onChange={props.onChange}
            value={props.item.values || ""}
            id={`standard-basic-${props.index}`} fullWidth placeholder={props.item.placeholder}
            InputProps={{ classes: { input: classes.resize, }, }}
          />
        </form>
      </Flex>
    )
  }
}

const NumberPicker = (props) => {
  const classes = numberPickerDropDownStyles()
  const preset = Property.getPreset()
  const minNumber = parseInt(props.item.min)
  const maxNumber = parseInt(props.item.max)
  const stepNumber = parseInt(props.item.step)
  let initialValue = parseInt(props.item.default)
  if (!isUndefined(props.item.values)) {
    initialValue = parseInt(props.item.values)
  }

  const [count, setCount] = React.useState(initialValue);

  const handleChange = (opera) => {
    let number;
    if (opera === 'minus' && (count - stepNumber) >= minNumber) {
      number = decreaseCount()
    } else if (opera === 'plus' && (count + stepNumber) <= maxNumber) {
      number = incrementCount()
    }
    props.item.values = number
    props.onChange({ target: { value: props.item.values } })
  };

  const incrementCount = () => {
    const sum = count + stepNumber
    setCount(sum);
    return sum
  };

  const decreaseCount = () => {
    const sum = count - stepNumber
    setCount(sum);
    return sum
  };

  props.item.values = count
  
  React.useEffect(() => {
    props.onChange({ target: { value: props.item.values } });
    // eslint-disable-next-line
  }, []); 

  return (
    <form className={classes.container} noValidate>
      <div style={{border: "1px solid #eaeaea", padding: "5px 20px", borderRadius: '40px'}}>
        <Flex container alignItems={"center"} width={"75px"}
              justifyContent={"center"}>
          <div onClick={() => handleChange('minus')}>
            <RemoveCircle style={{
              fontSize: 25,
              marginRight: 16,
              color: preset.app_home_color_secondary
            }}/>
          </div>
          <TextQuantity className={classes.textField} style={{
            minWidth: '20px',
            textAlign: 'center',
            borderBottomWidth: '3px',
            borderBottomColor: preset.app_home_color_secondary
          }}>{count}</TextQuantity>
          <div onClick={() => handleChange('plus')}>
            <AddCircle style={{
              fontSize: 25,
              marginLeft: 16,
              color: preset.app_home_color_secondary
            }}/>
          </div>
        </Flex>
      </div>
    </form>
  )
}

const ProductPrice = (props) => {

  const currencyCode = Property.getCurrencyCode()
  let initialValue = get(props, 'item.values', []).map(data => ({ ...data, value: get(data,'value',0)}))
  const [itemList, setItemList] = React.useState(initialValue);

  const plusMinus = (data, item) => {
    if (data === "plus") {
      const itemUpdate = map(itemList, function (a) {
        return a.name === item.name && a.price === item.price && a.max !== item.value ? { ...a, value: item.value + 1 } : a
      })
      setItemList(itemUpdate)
      props.item.values = itemUpdate
    } else if (data === "minus") {
      if (item.value >= 1) {
        const itemUpdate = map(itemList, function (a) {
          return a.name === item.name && a.price === item.price ? { ...a, value: item.value - 1 } : a
        })
        setItemList(itemUpdate)
        props.item.values = itemUpdate
      }
    }
    props.onChange({ target: { value: props.item.values } })
    props.refreshData(props.item, props.index)
  }
  props.item.values = itemList

  return (
    <Flex flex={1} flexDirection={"row"} margin={"16px 16px 16px 32px"}>
      {itemList.map((data, i) => (
        <Flex container key={i} justifyContent="space-between">
          <Flex margin={"16px 0"} width={'100px'}>
            <ProductPriceTitle>
              {data.name}
            </ProductPriceTitle>
            <ProductPriceValue>
            {Intl.NumberFormat(currencyCode, {
              style: "currency",
              currency: currencyCode,
              currencyDisplay: "code",
            }).format(data.price)}
            </ProductPriceValue>
            <ProductPriceMax>
              {`${props.t('MAXIMUM')} : ${data.max}`}
            </ProductPriceMax>
          </Flex>
          <Flex container flex={1} margin={"16px 0"} justifyContent={"flex-end"}>
            <CircleButton>
              <div onClick={() => plusMinus("minus", data)} disabled>
                <RemoveCircle style={{ fontSize: 35 }} />
              </div>
              <NumberStyle>{data.value}</NumberStyle>
              <div onClick={() => plusMinus("plus", data)}>
                <AddCircle style={{ fontSize: 35 }} />
              </div>
            </CircleButton>
          </Flex>
        </Flex>
      ))}
    </Flex>
  )
}

const Dropdown = (props) => {
  const itemList = get(props, 'item.values', [])
  const classes = dropDownStyles()

  const itemSelected = find(itemList,(item)=>{
    return item.select === true
  })

  let initialValue = get(props, 'item.default', '').toString()

  if (!isUndefined(itemSelected)) {
    initialValue = itemSelected.id.toString()
  }
  if (isEmpty(initialValue) && itemList.length > 0) {
    initialValue = itemList[0].id.toString()
  }

  const [currency, setCurrency] = React.useState(initialValue);

  const handleChange = (event) => {
    setCurrency(event.target.value);
    setSelected(event.target.value)
    props.onChange({ target: { value: props.item.values } })
  };

  const setSelected = (selected) => {
    props.item.values = map(get(props, 'item.values', []), (value) => {
      if (selected === value.id.toString()) {
        return { ...value, select: true }
      }
      return { ...value, select: false }
    })
  }
  React.useEffect(() => {
    setSelected(currency)
    props.onChange({ target: { value: props.item.values } });
    // eslint-disable-next-line
  }, []);

  return (
    <form className={classes.container} noValidate>
      <TextField
        id="outlined-select-currency-native"
        select
        value={currency}
        onChange={handleChange}
        SelectProps={{
          native: true,
        }}
        variant="outlined"
        className={classes.textField}
        InputProps={{
          classes: {
            input: classes.resize,
            root: classes.root
          },
        }}
      >
        {itemList.map((option, index) => {
          return (
            <option key={index} value={option.id}>
              {option.name}
            </option>
          )
        })}
      </TextField>
    </form>
  )
}

const DropdownList = (props) => {
  const itemList = get(props, 'item.values', [])
  const classes = dropDownStyles()

  const itemSelected = find(itemList,(item)=>{
    return item.select === true
  })

  let initialValue = get(props, 'item.default', '').toString()

  if (!isUndefined(itemSelected)) {
    initialValue = itemSelected.name.toString()
  }
  if (isEmpty(initialValue) && itemList.length > 0) {
    initialValue = itemList[0].name.toString()
  }

  const [currency, setCurrency] = React.useState(initialValue);

  const handleChange = (event) => {
    setCurrency(event.target.value);
    setSelected(event.target.value)
    props.onChange({ target: { value: props.item.values } })
  };

  const setSelected = (selected) => {
    props.item.values = map(get(props, 'item.values', []), (value) => {
      if (selected === value.name.toString()) {
        return { ...value, select: true }
      }
      return { ...value, select: false }
    })
  }

  React.useEffect(() => {
    setSelected(currency)
    props.onChange({ target: { value: props.item.values } });
    // eslint-disable-next-line
  }, []);

  return (
    <form className={classes.container} noValidate>
      <TextField
        id="outlined-select-currency-native"
        select
        value={currency}
        onChange={handleChange}
        SelectProps={{
          native: true,
        }}
        variant="outlined"
        className={classes.textField}
        InputProps={{
          classes: {
            input: classes.resize,
            root: classes.root
          },
        }}
      >
        {itemList.map((option, index) => {
          return (
            <option key={index} value={option.name}>
              {option.name}
            </option>
          )
        })}
      </TextField>
    </form>
  )
}

const PickTime = (props) => {
  const pluralize = (count, noun, suffix = 's') => `${count} ${noun}${count > 1 ? suffix : ''}`;
  const pluralizeKey = (count) =>
    count === 0 ? "zero" : count === 1 ? "one" : "other";
  const startTimeFromNow = parseInt(get(props, 'item.start_time_from_now', '0'))
  const endTimeFromNow = parseInt(get(props, 'item.end_time_from_now', '60'))
  const timeInterval = parseInt(get(props, 'item.time_interval', '1'))
  const enableAsap = get(props, 'item.enable_asap', false)
  let itemList = []
  if (enableAsap) {
    itemList.push({
      name: 'Now'
    })
  }
  for (var i = startTimeFromNow; i < endTimeFromNow; i += timeInterval) {
    const timeText =
      props.t(`MINUTES_DURATION.${pluralizeKey(i)}`, { count: i }) ||
      `${pluralize(i, "minute")}`;
    itemList.push({
      name: timeText
    })
  }
  const classes = dropDownStyles()

  const itemSelected = find(itemList, (item) => {
    return item.select === true
  })

  let initialValue = get(props, 'item.default', itemList.length > 0 && itemList[0].name).toString()

  if (!isUndefined(itemSelected)) {
    initialValue = itemSelected.name.toString()
  }

  const [time, setTime] = React.useState(initialValue);

  const handleChange = (event) => {
    setTime(event.target.value);
  };

  props.item.values = time
  return (
    <form className={classes.container} noValidate>
      <Flex container flex={1} justifyContent="center" alignItems="center">
          <AccessTime style={{fontSize: 35, marginRight: '10px'}}/>
          <TextField
            id="outlined-select-time-native"
            select
            value={time}
            onChange={handleChange}
            SelectProps={{
              native: true,
            }}
            variant="outlined"
            className={classes.textField}
            InputProps={{
              classes: {
                input: classes.resize,
                root: classes.root
              },
            }}
          >
            {itemList.map((option, index) => {
              return (
                <option key={index} value={option.name}>
                  {option.name}
                </option>
              )
            })}
          </TextField>
      </Flex>
    </form>
  )
}

const Uploader = (props) => {
  const preset = Property.getPreset()
  const [imageObj, setImageObj] = React.useState();
  const [uploadImage, setUploadImage] = React.useState(props.getDocument);
  const [loadingImage, setLoadingImage] = React.useState(false);
  const [loadedImage, setLoadedImage] = React.useState(false);
  const btnName = get(props, 'item.btn_name', 'UPLOAD')
  const classes = dropDownStyles()

  const handleDocument = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setLoadingImage(true)
      const file = e.target.files[0]
      let reader = new FileReader();
      reader.onload = function (e) {
        const returnObj = {
          name: 'document', value: {
            uri: e.target.result,
            name: file.name,
            type: file.type
          }
        };
        setUploadImage(returnObj.value);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleDocumentProcessing = (src, err) => {
    if (err) {
      alert(err)
    } else {
      let mimeType = src.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      const returnObj = {
        name: 'document', value: {
          uri: src,
          name: moment().unix().toString(),
          type: mimeType
        }
      };
      setImageObj(returnObj)
    }
    setLoadingImage(false)
    setLoadedImage(true)
    return imageObj;
  };
  props.item.values = uploadImage
  return (
    <form className={classes.container} noValidate>
      {uploadImage && <>
        <div style={{display: "none"}}>
          <ProcessImage
            image={uploadImage.uri}
            resize={{width: 800}}
            flip={{horizontal: false, vertical: false}}
            quality={75}
            processedImage={(src, err) => handleDocumentProcessing(src, err)}
            className="mx-auto w-48 mb-8 rounded-2xl"
            alt="passport"
          />
        </div>
        <img src={uploadImage.uri} className="mx-auto w-52 h-52 md:w-80 md:h-80 object-cover mb-8 rounded-2xl" alt="passport"/>
      </>
      }
      <label className="w-full">
        <input
          type="file"
          name="document"
          accept="image/*"
          onChange={handleDocument}
          className="border-b hidden w-full px-4 outline-none focus:outline-none type-normal large md:mb-10"
        />
        <p
          className="w-full type-title medium rounded-full py-6 max-w-md mx-auto mb-8 text-center"
          style={{
            backgroundColor: `${preset.app_home_color_primary}`,
            color: `${preset.app_home_text_call_to_action}`
          }}>
          {(!loadingImage && (loadedImage ? 'EDIT' : btnName)) || 'Loading...'}
        </p>
      </label>
    </form>
  )
}

const TwoRadioButton = (props) => {
  const preset = Property.getPreset()
  let initialValue = {}
  const classes = radioButtonStyles()
  props.item.values = [
    {name: "Yes", select: props.item.default === "Yes"},
    {name: "No", select: props.item.default === "No"},
  ]
  if (props.item.default) {
    initialValue = find(props.item.values,(value)=>{
      return value.select === true
    })
  }
  const [value, setValue] = React.useState(get(initialValue, 'name', ''));

  const handleChange = (event) => {
    setValue(event.target.value);
    props.item.values = props.item.values.map(value => {
      value.select = value.name === event.target.value;
      return value
    })
  };

  return (
    <Flex flex={1} flexDirection={"row"} margin={"16px 32px"}>
      <FormControl component="fieldset" style={{ display: 'block' }}>
        <RadioGroup value={value} onChange={handleChange} style={{ flexDirection: 'row', justifyContent: 'center', marginBottom:'5px'}}>
          {
            props.item.values.map((item, index) => {
                if (value === item.name) {
                  item.select = true
                } else {
                  item.select = false
                }
                return (
                  <FormControlLabel value={item.name}
                                    style={{ alignItems: 'center', justifyContent: 'center', marginBottom:'5px', marginLeft: '0'}}
                                    control={<Radio style={{ color: `${preset.app_home_color_secondary}`, paddingTop: '3px' }} />}
                                    label={item.name} key={index}
                                    classes={{ label: classes.label }} />
                )
              }
            )
          }
        </RadioGroup>
      </FormControl>
    </Flex>
  )
}

const Signature = (props) => {
  const [sig, setSig] = React.useState();
  const [canvas, setCanvas] = React.useState();

  const handleChange = (value) => {
    setSig(value);
    props.item.values = value
    props.onChange({ target: { value } })
  };
  return (
    <Flex flex={1} flexDirection={"row"} margin={"16px 32px"}>
      <SignatureSelector props={props}
                         setSignature={handleChange}
                         getSignature={sig}
                         setRef={setCanvas}
                         getRef={canvas}
      />
    </Flex>
  )
}

const toTimestamp = (date) => {
  if (date instanceof Date) {
    return Math.round(date.getTime() / 1000)
  } else if (date instanceof String) {
    return Math.round(Date.parse(date).getTime() / 1000)
  } else if (Number.isInteger(date)) {
    return Math.round(date / 1000)
  } else {
    return date
  }
}

const DatePicker = (props) => {
  const title = props.item.title || 'Date'
  const minBookingNoticeDays = props.item.minBookingNoticeDays || 0
  const fromDate = moment().add(minBookingNoticeDays, 'days')
  const classes = useStyles();
  let initialValue = formatDate(fromDate)
  if (props.item.values) {
    initialValue = formatDate(props.item.values)
  }
  const [selectedDate, setSelectedDate] = React.useState(initialValue);
  props.item.values = selectedDate
  const handleChange = ({ target }) => {
    setSelectedDate(formatDate(target.value));
    props.onChange({ target: { value: formatDate(target.value) } })
  }
  const presets = Property.getPreset() || {}
  return (
      <>
        <form className={classes.container}>
          <div className="w-full date-selector">
            <DateTimePickerComponent
                modalTitle={title}
                getDate={selectedDate}
                primaryColor={presets.app_home_color_primary}
                buttonStyleName={presets.buttonStyleName}
                handleChange={handleChange}
                from={fromDate.format('YYYY-MM-DD')}
                to={moment().add(90, 'days').format('YYYY-MM-DD')}
                dateType="date"
            />
          </div>
        </form>
      </>
  );
}

const TimePicker = (props) => {
  const classes = timePickerStyles();
  const startTime = get(props, 'item.start')
  const endTime = get(props, 'item.end')
  let initialValue = "00:00"
  if (isUndefined(props.item.values)) {
    if (props.item.default !== "00:00") {
      initialValue = props.item.default
    }
  } else {
    initialValue = props.item.values
  }

  const [selectedTime, setSelectedTime] = React.useState(initialValue);

  props.item.values = selectedTime
  const handleTimeChange = (event) => {
    setSelectedTime(event.target.value);
    props.onChange({ target: { value: event.target.value } })
  };
  const presets = Property.getPreset() || {}
  return (
    <form className={classes.container} noValidate>
      <DateTimePickerComponent
        enableTime
        onlyTime
        modalTitle={get(props, 'item.title')}
        getTime={selectedTime}
        primaryColor={presets.app_home_color_primary}
        buttonStyleName={presets.buttonStyleName}
        handleChange={handleTimeChange}
        timeStart={startTime}
        timeEnd={endTime}
        InputProps={{
          classes: {
            input: classes.resize,
            root: classes.root
          }
        }}
        step={get(props, 'item.step')}
      />
    </form>
  );
}

const DateTimePickerComponents = (props) => {
  const title = props.item.title || 'Date and time'
  const presets = Property.getPreset() || {}
  const classes = dateTimeStyles();
  const minBookingNoticeDays = props.item.minBookingNoticeDays || 0
  const fromDate = moment().add(minBookingNoticeDays, 'days')
  let initialTimeValue = moment().format("HH:mm")
  const currentDate = formatDate(fromDate)
  if (props.item.time_default !== "00:00") {
    initialTimeValue = props.item.time_default
  }
  const [timestamp, setTimestamp] = React.useState(toTimestamp(new Date()));
  const [arrivalDate, setArrivalDate] = React.useState(currentDate || '');
  const [arrivalTime, setArrivalTime] = React.useState(initialTimeValue || '');

  props.item.timestamp = timestamp
  props.item.values = arrivalDate + "T" + arrivalTime

  const handleDateTimeChange = ({ target }) => {
    if (target.name === 'arrivalDate') {
      setTimestamp(toTimestamp(Date.parse(target.value)))
      const arrivalDateValue = formatDate(target.value)
      setArrivalDate(arrivalDateValue)
      props.onChange({ target: { value: arrivalDateValue } })
    } else if (target.name === 'arrivalTime') {
      const arrivalDateValue = target.dateTime.replace(" ","T")
      setTimestamp(toTimestamp(Date.parse(arrivalDateValue)))
      setArrivalTime(target.value)
      props.onChange({ target: { value: arrivalDateValue } })
    } else {
      props.onChange({ target: { value: props.item.values } })
    }
  };

  return (
      <>
        <form className={classes.container} noValidate>
          <div className="w-full date-selector">
            <DateTimePickerComponent
                enableTime
                from={fromDate.format('YYYY-MM-DD')}
                to={moment().add(90, 'days').format('YYYY-MM-DD')}
                modalTitle={title}
                getDate={arrivalDate}
                getTime={arrivalTime}
                dateName="arrivalDate"
                timeName="arrivalTime"
                showCombinedTime
                present
                ampm={presets.standard_time_hour_format === "12-hour"}
                primaryColor={presets.app_home_color_primary}
                buttonStyleName={presets.buttonStyleName}
                handleChange={handleDateTimeChange}
                timeStart={props.item.time_start}
                timeEnd={props.item.time_end}
                step={get(props, 'item.time_step')}
            />
          </div>
        </form>
      </>
  );
}

const RadioButton = (props) => {

  const preset = Property.getPreset()

  let initialValue = {}
  const classes = radioButtonStyles()

  if (props.item.default) {
    initialValue = find(props.item.values, (value)=>{
      return value.select === true
    })
    if (isUndefined(initialValue)) {
      initialValue = props.item.values[parseInt(props.item.default)]
    }
    if (isUndefined(initialValue)) {
      initialValue = find(props.item.values, (value)=>{
        return value.name.toLowerCase() === props.item.default.toLowerCase() || value.description.toLowerCase() === props.item.default.toLowerCase()
      })
    }
  }
  const [value, setValue] = React.useState(get(initialValue, 'name', ''));

  const handleChange = (event) => {
    setValue(event.target.value || event.target.description);
  };

  return (
    <Flex flex={1} flexDirection={"row"} margin={"16px 32px"}>
      <FormControl component="fieldset">
        <RadioGroup value={value} onChange={handleChange}>
          {
            props.item.values.map((item, index) => {
              if (value === item.name || value === item.description) {
                item.select = true
              } else {
                item.select = false
              }
              if (!item.select && props.item.showSelectedOnly) return null;

              return (
                <FormControlLabel value={item.name || item.description} style={{ alignItems: `flex-start`,marginBottom:'5px'}}
                                  control={<Radio style={{ color: `${preset.app_home_color_secondary}`,paddingTop: '3px' }} />}
                                  label={item.name || item.description} key={index}
                  classes={{ label: classes.label }} />
              )
            })
          }
        </RadioGroup>
      </FormControl>
    </Flex>
  )
}

const RadioButtonPrice = (props) => {
  let initialValue = {}
  const classes = radioButtonStyles()
  const currencyCode = Property.getCurrencyCode()
  const preset = Property.getPreset()

  if (props.item.default) {
    initialValue = find(props.item.values,(value)=>{
      return value.select === true
    })
    if (isUndefined(initialValue)) {
      initialValue = props.item.values[parseInt(props.item.default)]
    }
  }
  const [value, setValue] = React.useState(get(initialValue, 'name', ''));

  const handleChange = (event) => {
    setValue(event.target.value);

    const result = props.item.values.map(value => {
      value.select = value.name === event.target.value;
      return value
    })
    props.item.values = result
    props.refreshData(props.item, props.index)
    props.onChange({ target: { value: result } })
  };

  return (
    <Flex flex={1} flexDirection={"row"} margin={"16px 16px 16px 32px"}>
      <FormControl component="fieldset">
        <RadioGroup value={value} onChange={handleChange}>
          {
            props.item.values.map((item, index) => {
              if (value === item.name) {
                item.select = true
              } else {
                item.select = false
              }
              return (
                <FormControlLabel
                  classes={{ label: classes.label }}
                  value={item.name}
                  control={<Radio style={{ color: `${preset.app_home_color_secondary}` }} />}
                  label={item.name + " (+" + currencyCode + " " + item.price + ")"}
                  key={index} />
              )
            }
            )
          }
        </RadioGroup>
      </FormControl>
    </Flex>
  )
}

const CheckBoxs = (props) => {
  const classes = checkBoxStyles();
  const [value, setValue] = React.useState(props.item.values);
  const handleChange = (name) => {
    const selectedCount = value.filter((data) => data.select).length;
    const result = value.map((data) => {
      if (name === data.name) {
        if (data.select) {
          return { ...data, select: false };
        }
        if (
          !data.select &&
          selectedCount >= (props.item.selection_limit || value.length) // default no limit
        ) {
          return data;
        }
        return { ...data, select: true };
      }
      return data;
    });
    setValue(result);
    props.item.values = result;
    props.onChange({ target: { value: props.item.values } });
  };

  return (
    <Flex flex={1}>
      {
        value.map((item, index) => {
          return (
            <Flex flex={1} margin={"16px 32px"} key={index}>
              <FormControlLabel
                onChange={() => handleChange(item.name)}
                classes={{
                  label: classes.label
                }}
                control={<Checkbox
                  checked={!!item.select}
                  value={item.name}
                  className={classes.root}
                  disableRipple
                  color="default"
                  checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                  icon={<span className={classes.icon} />}
                  inputProps={{ 'aria-label': 'decorative checkbox' }} />}
                label={item.name}
                labelPlacement="end"
              />
              <BorderLine style={{ marginTop: "10px" }} />
            </Flex>
          )
        }
        )
      }
    </Flex>
  )
}

const CheckBoxsPrice = (props) => {
  const classes = checkBoxStyles();
  // Find initial default item
  const initialValue = props.item.values.find((v) => v.default) || {};
  const currencyCode = Property.getCurrencyCode();
  const [valueCheckBoxPrice, setValueCheckBoxPrice] = React.useState(initialValue.name);

  const handleChange = (event, item) => {
    const selectedCount = props.item.values.filter((v) => v.select).length;
    if (item.select) {
      item.select = false;
    } else {
      if (
        props.item.selection_limit > 0 &&
        selectedCount >= props.item.selection_limit
      ) {
        return; // do nothing if limit reached
      }
      item.select = true;
    }

    item.default = item.select;

    props.refreshData(props.item, props.index);
    setValueCheckBoxPrice(event.target.value);
  };

  return (
    <Flex flex={1}>
      {
        props.item.values.map((item, index) => {
          return (
            <Flex flex={1} margin={"16px 32px"} key={index}>
              <FormControlLabel
                onChange={(event) => handleChange(event, item)}
                value={valueCheckBoxPrice}
                classes={{
                  label: classes.label
                }}
                control={<Checkbox
                  value={item.name}
                  checked={!!item.select}
                  className={classes.root}
                  color="default"
                  checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                  icon={<span className={classes.icon} />}
                  inputProps={{ 'aria-label': 'decorative checkbox' }} />}
                label={item.name + " (+" + currencyCode + " " + item.price + ")"}
                labelPlacement="end"
              />
              <BorderLine style={{ marginTop: "10px" }} />
            </Flex>
          )
        }
        )
      }
    </Flex>
  )
}

const RenderDefault = (props) => {
  return (
    <Flex flex={1}>

    </Flex>
  )
}

const NumberStyle = styled.div`
  font-weight: normal;
  text-decoration: underline;
  font-size: 20px;
`;

const CircleButton = styled.div`
  display: flex;
  background-color: white;
  border-radius: 32px;
  border-style: solid;
  border-width: 1px;
  border-color: gray;
  width: 90%;
  height: auto;
  max-height: 45px;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
`;
const ProductPriceTitle = styled.div`
  font-size: 11pt;
  margin: 1px 0;
`;
const ProductPriceValue = styled.div`
  font-size: 11pt;
  margin: 1px 0;
`;
const ProductPriceMax = styled.div`
  font-size: 8pt;
  color: gray;
`;

const TitleSelector = styled.div`
  color: #7A7A7A;
  align-self: center;
  font-size: 15px;
`;

const TitleSelectorRight = styled.div`
  color: #7A7A7A;
  align-self: center;
  font-size: 15px;
  text-align: right;
  padding: 0 16px 0 0;
`;

const TitleAlert = styled.div`
  color: red;
  padding: 16px 0;
  text-align: center;
  font-size: 16px;
`;

const FlexContainer = styled.div`
  display: flex;
  padding: 12px 16px;
  justify-content: space-between;
`;

const StaticText = styled.div`
  font-weight: lighter;
  color: gray;
  text-align: center;
  padding: 16px 0;
  font-size: 15px;
`;

const BorderLine = styled.p`
  border-width: thin;
  border-style: none none inset none;
`;

const textInputStyles = makeStyles(() => ({
  resize: {
    fontSize: 14,
    lineHeight: 1
  },
  notchedOutline: {
    borderWidth: "1px !important",
    borderColor: "gray !important"
  }
}));

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center",
    margin: "16px 0 0 0"
  },
  textField: {
    minWidth: "80%",
  },
  resize: {
    fontSize: 18,
    color: "gray",
    textAlign: "center",
    verticalAlign: "middle"
  },
  root: {
    borderRadius: 24,
    border: 0,
    color: 'gray',
    height: 48,
    justifyContent: "center",
    lineHeight: 1,
    padding: "0 0 0 20px"
  },
}));

const timePickerStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center",
    margin: "16px 0 0 0"
  },
  textField: {
    minWidth: "80%",
  },
  resize: {
    fontSize: 18,
    color: "gray",
    textAlign: "center",
  },
  root: {
    borderRadius: 24,
    border: 0,
    color: 'gray',
    height: 48,
    justifyContent: "center",
    lineHeight: 1,
    padding: "0 0 0 20px"
  },
}));

const dateTimeStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center",
    margin: "16px 0 0 0"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: "80%",
  },
  resize: {
    fontSize: 16,
    color: "gray",
    textAlign: "center",
  },
  root: {
    borderRadius: 24,
    border: 0,
    color: 'gray',
    height: 48,
    lineHeight: 1,
    padding: "0 0 0 20px"
  },
}));

const checkBoxStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  label: {
    color: "gray",
    fontSize: "11pt"
  }
});

const numberPickerDropDownStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center",
    margin: "16px 0 0 0"
  },
  textField: {
    fontSize: 14,
    width: "50%",
  },
  resize: {
    fontSize: 14,
    color: "gray",
    paddingLeft: "45% !important"
  },
  root: {
    color: 'gray',
    height: 48,
    justifyContent: "center"
  },
}));

const dropDownStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: "center",
    margin: "16px 0 0 0"
  },
  textField: {
    width: "50%",
  },
  resize: {
    fontSize: 14,
    color: "gray"
  },
  root: {
    color: 'gray',
    height: 48,
    justifyContent: "center"
  },
}));

const radioButtonStyles = makeStyles({
  label: {
    color: "gray",
    fontSize: "11pt"
  }
});

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}
